import { prefix } from './constants.js';

/**
 * @typedef {import('../types.d.ts').BaseInterface} BaseInterface
 * @typedef {import('../types.d.ts').BaseConfig} BaseConfig
 */

/**
 * Add basic capabilities to the given class.
 *
 * @template {CustomElementConstructor} T
 * @param    {T} Class A class to add the Base capabilities to.
 * @returns  {T & BaseInterface}
 */
export function withBase(Class) {
  return class extends Class {
    /**
     * @type {BaseConfig}
     */
    static config = {
      name: 'base',
    };

    /**
     * Final name of the component to be used in the DOM.
     */
    static get $name() {
      return `${prefix}${this.config.name}`;
    }

    /**
     * Register the component to the global customElements registry.
     */
    static $register() {
      if (this.config.debug) {
        console.log(`[${this.config.name}] $register`);
      }

      try {
        customElements.define(this.$name, this);
      } catch {
        if (this.config.debug) {
          console.error(`[${this.$name}] Element already registered`);
        }
        // Silence is golden.
      }
    }
  };
}
